import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "p-5"
};
const _hoisted_2 = { class: "columns is-variable is-5" };
const _hoisted_3 = { class: "column is-narrow" };
const _hoisted_4 = { class: "horizontal" };
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("h1", { class: "subtitle mb-4" }, "Sites", -1);
const _hoisted_6 = {
    key: 0,
    class: "ml-5 pb-4"
};
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("h3", null, "Manage locations and assigned caseworkers", -1);
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("div", { class: "column" }, null, -1);
const _hoisted_9 = { class: "column is-narrow pt-3" };
const _hoisted_10 = { class: "tabs is-toggle is-small mb-3" };
const _hoisted_11 = { style: { "justify-content": "right" } };
const _hoisted_12 = { class: "field" };
const _hoisted_13 = { class: "control" };
const _hoisted_14 = { class: "table is-hoverable is-fullwidth" };
const _hoisted_15 = /*#__PURE__*/ _createElementVNode("th", { style: { "min-width": "50%" } }, "Site Name", -1);
const _hoisted_16 = { key: 0 };
const _hoisted_17 = { key: 0 };
const _hoisted_18 = /*#__PURE__*/ _createElementVNode("td", {
    colspan: "999",
    style: { "text-align": "center" },
    class: "pt-5"
}, "Select a partner", -1);
const _hoisted_19 = [
    _hoisted_18
];
const _hoisted_20 = { key: 1 };
const _hoisted_21 = { key: 2 };
const _hoisted_22 = /*#__PURE__*/ _createElementVNode("td", {
    colspan: "999",
    style: { "text-align": "center" },
    class: "pt-5"
}, "No results", -1);
const _hoisted_23 = [
    _hoisted_22
];
const _hoisted_24 = { key: 0 };
const _hoisted_25 = {
    key: 0,
    class: "columns"
};
import { useAsync } from "@/composables/useAsync";
import { useFilterForAsync } from "@/composables/useFilter";
import { isFeatureEnabled, isNetworkAdmin, sessionState } from "@/core/session";
import { notifyError, notifyNetworkError, notifySuccess } from "@/core/utils";
import { computed, ref, watch } from "vue";
import { useRouter } from "vue-router";
import { apiPartners } from "../partners/api";
import SiteProfileEditor from "./SiteProfileEditor.vue";
import { apiSites } from "./api";
import { Site, User, Core } from "@minicity/core";
import PartnerSelectField from "@/features/partners/PartnerSelectField.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'SiteListingPanel',
    setup(__props) {
        const router = useRouter();
        const inProgressAction = ref(null);
        // Fetch birth records from API
        const sites = useAsync();
        const allPartners = ref(null);
        // Search / category filtering
        const { searchQuery, filtered: filteredSites } = useFilterForAsync(sites, (s) => s.partner.name + " " + s.name);
        const activeCategory = ref("ALL");
        const sitesToDisplay = computed(() => {
            return filteredSites.value.filter(site => {
                if (activeCategory.value == "ALL")
                    return true;
                let isActive = site.partner.shown;
                if (activeCategory.value == "ACTIVE" && !isActive)
                    return false;
                if (activeCategory.value == "HIDDEN" && isActive)
                    return false;
                return true;
            });
        });
        // Site creation
        const createSiteModalActive = ref(false);
        const profileEditorElem = ref();
        const siteToBeCreatedPartnerId = ref(null);
        const siteToBeCreated = ref({
            name: '',
            partner: {},
            profile: {
                phone: '',
                address: {}
            },
            nature: Site.Nature["Physical"]
        });
        const createSite = () => {
            if (inProgressAction.value)
                return;
            if (!siteToBeCreatedPartnerId.value) {
                notifyError("Please select a partner");
                return;
            }
            if (!profileEditorElem.value.areAllFieldsValid) {
                notifyError("Please check for invalid form inputs");
                return;
            }
            createSiteModalActive.value = false;
            inProgressAction.value = 'createSite';
            apiSites.create(siteToBeCreatedPartnerId.value, {
                name: siteToBeCreated.value.name,
                profile: siteToBeCreated.value.profile,
                nature: siteToBeCreated.value.nature
            })
                .then(newId => {
                notifySuccess("Site created");
                router.push(`/sites/${newId}`);
            })
                .catch(err => {
                notifyNetworkError("Failed to create site", err);
            })
                .finally(() => {
                inProgressAction.value = null;
            });
        };
        if (sessionState.session) {
            switch (sessionState.session.user.role) {
                case User.Role.NETWORK_ADMIN:
                    sites.fetch(apiSites.getForNetwork(), "Failed to load sites");
                    break;
                case User.Role.PARTNER_ADMIN:
                    sites.fetch(apiSites.getForPartner(sessionState.session.partnerId), "Failed to load sites");
                    break;
                default:
                    console.error("Unexpected user type");
                    break;
            }
            if (isNetworkAdmin()) {
                // Look up all partners (used when creating a new site)
                apiPartners.getForNetwork()
                    .then((partnersInNetwork) => {
                    partnersInNetwork.sort((a, b) => a.name.localeCompare(b.name));
                    let partnersByName = {};
                    for (let partner of partnersInNetwork) {
                        partnersByName[partner.name] = partner.id;
                    }
                    allPartners.value = partnersByName;
                })
                    .catch(err => notifyNetworkError("Failed to load partners", err));
            }
        }
        const partnerId = ref(null);
        watch(partnerId, () => {
            sites.fetch(partnerId.value ? apiSites.getForPartner(partnerId.value) : apiSites.getForNetwork(), "Failed to load sites");
        });
        return (_ctx, _cache) => {
            const _component_SaveButton = _resolveComponent("SaveButton");
            const _component_LoadingTableRow = _resolveComponent("LoadingTableRow");
            const _component_SiteBadge = _resolveComponent("SiteBadge");
            const _component_OpenTasksIndicator = _resolveComponent("OpenTasksIndicator");
            const _component_router_link = _resolveComponent("router-link");
            const _component_PartnerBadge = _resolveComponent("PartnerBadge");
            const _component_FormSelectField = _resolveComponent("FormSelectField");
            const _component_ModalDialog = _resolveComponent("ModalDialog");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                (_unref(isFeatureEnabled)('SITES'))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _createElementVNode("div", _hoisted_2, [
                            _createElementVNode("div", _hoisted_3, [
                                _createElementVNode("div", _hoisted_4, [
                                    _hoisted_5,
                                    (siteToBeCreatedPartnerId.value || allPartners.value)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                            _createVNode(_component_SaveButton, {
                                                label: "Add Site",
                                                icon: "fa-plus",
                                                action: "createSite",
                                                inProgressAction: inProgressAction.value,
                                                onClick: _cache[0] || (_cache[0] = ($event) => (createSiteModalActive.value = true))
                                            }, null, 8, ["inProgressAction"])
                                        ]))
                                        : _createCommentVNode("", true)
                                ]),
                                _hoisted_7
                            ]),
                            (_unref(isNetworkAdmin)())
                                ? (_openBlock(), _createBlock(PartnerSelectField, {
                                    key: 0,
                                    modelValue: partnerId.value,
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((partnerId).value = $event)),
                                    partners: allPartners.value,
                                    allowSelectAll: ""
                                }, null, 8, ["modelValue", "partners"]))
                                : _createCommentVNode("", true),
                            _hoisted_8,
                            _createElementVNode("div", _hoisted_9, [
                                _createElementVNode("div", _hoisted_10, [
                                    _createElementVNode("ul", _hoisted_11, [
                                        _createElementVNode("li", {
                                            class: _normalizeClass({ 'is-active': activeCategory.value == 'ALL' })
                                        }, [
                                            _createElementVNode("a", {
                                                onClick: _cache[2] || (_cache[2] = ($event) => (activeCategory.value = 'ALL'))
                                            }, "All")
                                        ], 2),
                                        _createElementVNode("li", {
                                            class: _normalizeClass({ 'is-active': activeCategory.value == 'ACTIVE' })
                                        }, [
                                            _createElementVNode("a", {
                                                onClick: _cache[3] || (_cache[3] = ($event) => (activeCategory.value = 'ACTIVE'))
                                            }, "Active")
                                        ], 2),
                                        _createElementVNode("li", {
                                            class: _normalizeClass({ 'is-active': activeCategory.value == 'HIDDEN' })
                                        }, [
                                            _createElementVNode("a", {
                                                onClick: _cache[4] || (_cache[4] = ($event) => (activeCategory.value = 'HIDDEN'))
                                            }, "Hidden")
                                        ], 2)
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_12, [
                                    _createElementVNode("div", _hoisted_13, [
                                        _withDirectives(_createElementVNode("input", {
                                            class: "input",
                                            type: "text",
                                            placeholder: "Search",
                                            autofocus: "",
                                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => (_isRef(searchQuery) ? (searchQuery).value = $event : null))
                                        }, null, 512), [
                                            [_vModelText, _unref(searchQuery)]
                                        ])
                                    ])
                                ])
                            ])
                        ]),
                        _createElementVNode("table", _hoisted_14, [
                            _createElementVNode("thead", null, [
                                _createElementVNode("tr", null, [
                                    _hoisted_15,
                                    (_unref(isNetworkAdmin)())
                                        ? (_openBlock(), _createElementBlock("th", _hoisted_16, "Partner"))
                                        : _createCommentVNode("", true)
                                ])
                            ]),
                            _createElementVNode("tbody", null, [
                                (_unref(isNetworkAdmin)() && partnerId.value == 'none')
                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_17, _hoisted_19))
                                    : (_unref(sites).status == 'loading')
                                        ? (_openBlock(), _createElementBlock("tr", _hoisted_20, [
                                            _createVNode(_component_LoadingTableRow)
                                        ]))
                                        : (sitesToDisplay.value.length == 0)
                                            ? (_openBlock(), _createElementBlock("tr", _hoisted_21, _hoisted_23))
                                            : (_openBlock(true), _createElementBlock(_Fragment, { key: 3 }, _renderList(sitesToDisplay.value, (site) => {
                                                return (_openBlock(), _createElementBlock("tr", {
                                                    key: site.id
                                                }, [
                                                    _createElementVNode("td", null, [
                                                        _createVNode(_component_router_link, {
                                                            to: `/sites/${site.id}`,
                                                            class: "horizontal"
                                                        }, {
                                                            default: _withCtx(() => [
                                                                _createVNode(_component_SiteBadge, { site: site }, null, 8, ["site"]),
                                                                _createVNode(_component_OpenTasksIndicator, {
                                                                    entityType: _unref(Core).EntityType['Partner Site'],
                                                                    entityId: site.id
                                                                }, null, 8, ["entityType", "entityId"])
                                                            ]),
                                                            _: 2
                                                        }, 1032, ["to"])
                                                    ]),
                                                    (_unref(isNetworkAdmin)())
                                                        ? (_openBlock(), _createElementBlock("td", _hoisted_24, [
                                                            _createVNode(_component_router_link, {
                                                                to: `/sites/${site.id}`
                                                            }, {
                                                                default: _withCtx(() => [
                                                                    _createVNode(_component_PartnerBadge, {
                                                                        partner: site.partner,
                                                                        disabled: !site.partner.shown,
                                                                        noLink: ""
                                                                    }, null, 8, ["partner", "disabled"])
                                                                ]),
                                                                _: 2
                                                            }, 1032, ["to"])
                                                        ]))
                                                        : _createCommentVNode("", true)
                                                ]));
                                            }), 128))
                            ])
                        ])
                    ]))
                    : _createCommentVNode("", true),
                _createVNode(_component_ModalDialog, {
                    active: createSiteModalActive.value,
                    title: "Create Site",
                    "allow-close": true,
                    onClose: _cache[8] || (_cache[8] = ($event) => (createSiteModalActive.value = false)),
                    "first-button-text": "Go Back",
                    "first-button-severity": "link",
                    onFirstbuttonselected: _cache[9] || (_cache[9] = ($event) => (createSiteModalActive.value = false)),
                    "second-button-text": "Create",
                    "second-button-severity": "primary",
                    onSecondbuttonselected: _cache[10] || (_cache[10] = ($event) => (createSite()))
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("div", null, [
                            (_unref(isNetworkAdmin)() && allPartners.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                    _createVNode(_component_FormSelectField, {
                                        label: "Partner",
                                        modelValue: siteToBeCreatedPartnerId.value,
                                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((siteToBeCreatedPartnerId).value = $event)),
                                        options: allPartners.value,
                                        validator: (fieldId, val) => val != null
                                    }, null, 8, ["modelValue", "options", "validator"])
                                ]))
                                : _createCommentVNode("", true),
                            _createVNode(SiteProfileEditor, {
                                modelValue: siteToBeCreated.value,
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((siteToBeCreated).value = $event)),
                                ref_key: "profileEditorElem",
                                ref: profileEditorElem
                            }, null, 8, ["modelValue"])
                        ])
                    ]),
                    _: 1
                }, 8, ["active"])
            ], 64));
        };
    }
});
